var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.isLogined)?_c('side-bar'):_vm._e(),_c('v-main',[(_vm.hasPermission)?_c('router-view'):_c('div',[_vm._v("Permission denied")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }